function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import i18n from 'invision-core/src/components/i18n/i18n';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/common.constants';
import LocaleKeys from '../../locales/keys';
import { MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { getFormattedServiceAttributeValue } from './services.list.selectors.helper';
import { getCustomerAdditionalPropertiesSortedByDisplayOrder, getCustomerCurrencyName, getCustomerHomeCountryName, getCustomerInvoiceDetailStatus } from '../helpers/customer.selectors.helpers';
import { CUSTOMER_CATEGORY } from '../../components/createCustomerPopup/create.customer.popup.constants';
import { codeTypeFilter } from 'invision-core/src/components/codeTypeFilters/code.type.filter';
import { getNameByCountryCode } from '../../components/customer/customer.helper';
import { InvoiceDisplaySelector } from '../../components/createCustomerPopup/customer.form.dropdown.selectors';
import { SubscriberAdditionalPropertiesSelector } from 'invision-core/src/components/metadata/codes/codes.additional.properties.selectors';
import { CustomerSearchResultsViewModelSelector } from './search.other.customers.selectors';
import { CUSTOMER_STATE } from '../../components/shared/constants/customer.constants';
export var NON_TRANSFERABLE_REASON_CODES = {
  NONE: 0,
  BULK: 1,
  CONTRACT: 2,
  PREPAID: 3,
  OPEN_ORDER: 4,
  OPEN_MOBILE_NUMBER_PORT: 5
};
export var TransferWizardStoreSelector = function TransferWizardStoreSelector(state) {
  return state.customercare.recoverableUiState.transferWizard;
};
export var IsFetchingTransferableOfferingsSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferStore) {
  return transferStore.isFetchingTransferableOfferings;
});
export var TransferableOfferingsSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferStore) {
  return transferStore.offerings;
});
export var OfferingsMetadataSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferStore) {
  return transferStore.offeringsMetadata;
});
export var OfferingInstancesSelectedForTransferSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferStore) {
  return transferStore.offeringsSelectedForTransfer;
});
var getTransferableReason = function getTransferableReason(nonTransferableReasonCode) {
  switch (nonTransferableReasonCode) {
    case NON_TRANSFERABLE_REASON_CODES.BULK:
      return LocaleKeys.TRANSFER.NON_TRANSFERABLE_REASON.BULK;
    case NON_TRANSFERABLE_REASON_CODES.CONTRACT:
      return LocaleKeys.TRANSFER.NON_TRANSFERABLE_REASON.CONTRACT;
    case NON_TRANSFERABLE_REASON_CODES.PREPAID:
      return LocaleKeys.TRANSFER.NON_TRANSFERABLE_REASON.PREPAID;
    case NON_TRANSFERABLE_REASON_CODES.OPEN_ORDER:
      return LocaleKeys.TRANSFER.NON_TRANSFERABLE_REASON.OPEN_ORDER;
    case NON_TRANSFERABLE_REASON_CODES.OPEN_MOBILE_NUMBER_PORT:
      return LocaleKeys.TRANSFER.NON_TRANSFERABLE_REASON.OPEN_MOBILE_NUMBER_PORT;
    default:
      return LocaleKeys.TRANSFER.NON_TRANSFERABLE_REASON.DEFAULT;
  }
};
export var TransferableOfferingsViewModelSelector = createImmutableSelector([MetadataCodeTypeDictionarySelector(CODES.RegularExpression), MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), OfferingsMetadataSelector, OfferingInstancesSelectedForTransferSelector, TransferableOfferingsSelector], function (regularExpressionCodeTable, serviceAttributeCodeTable, offeringsMetadata, offeringsSelectedForTransfer, transferableOfferings) {
  return !transferableOfferings.length || !offeringsMetadata.length || !regularExpressionCodeTable || !serviceAttributeCodeTable ? EMPTY_ARRAY : transferableOfferings.map(function (offering) {
    var metadata = offeringsMetadata.find(function (offeringMetadata) {
      return offeringMetadata.Id === offering.OrderedOfferingId;
    });
    var services = pathOr(0, ['ServiceAttributeValues', 'length'], offering) ? offering.ServiceAttributeValues.map(function (service) {
      return getFormattedServiceAttributeValue(service.ServiceAttributeId, service.Value, serviceAttributeCodeTable, regularExpressionCodeTable);
    }) : EMPTY_ARRAY;
    return {
      currencyCode: metadata.CurrencyCode,
      displayName: metadata.Name,
      isSelected: offeringsSelectedForTransfer.some(function (offeringInstanceId) {
        return offeringInstanceId === offering.OfferingInstanceId;
      }),
      isTransferable: offering.IsTransferable,
      offeringId: offering.OrderedOfferingId,
      offeringInstanceId: offering.OfferingInstanceId,
      nonTransferableReason: offering.IsTransferable ? '' : i18n.translate(getTransferableReason(offering.NonTransferableReasonCode)),
      services: services,
      thumbnailUrl: metadata.ThumbnailUrl,
      total: offering.Total
    };
  });
});
export var IsValidatingSubscriberForTransferSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferWizardStore) {
  return transferWizardStore.isValidatingSubscriberForTransfer;
});
export var SelectedDestinationCustomerSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferWizardStore) {
  return transferWizardStore.selectedDestinationCustomer || EMPTY_OBJECT;
});
export var IsFetchingDestinationCustomerDataSelector = createImmutableSelector([TransferWizardStoreSelector], function (transferWizardStore) {
  return transferWizardStore.isFetchingDestinationCustomerData;
});
export var DestinationCustomerCurrencyNameSelector = createImmutableSelector([SelectedDestinationCustomerSelector, MetadataCodeTypeSelector(CODES.Currency)], function (customer, subscriberCurrencies) {
  return getCustomerCurrencyName(customer, subscriberCurrencies);
});
export var DestinationCustomerHomeCountryNameSelector = createImmutableSelector([SelectedDestinationCustomerSelector, MetadataCodeTypeSelector(CODES.AddressCountry)], function (customer, homeCountries) {
  return getCustomerHomeCountryName(customer, homeCountries);
});
export var DestinationCustomerInvoiceDetailStatus = createImmutableSelector([SelectedDestinationCustomerSelector, MetadataCodeTypeSelector(CODES.InvoiceDetailLevel)], function (customer, invoiceDetailLevels) {
  return getCustomerInvoiceDetailStatus(customer, invoiceDetailLevels);
});
export var DestinationCustomerAdditionalPropertiesSelector = createImmutableSelector([SelectedDestinationCustomerSelector], function (customer) {
  return customer.AdditionalProperties || EMPTY_ARRAY;
});
export var DestinationCustomerInformationViewModelSelector = createImmutableSelector([SelectedDestinationCustomerSelector, DestinationCustomerCurrencyNameSelector, DestinationCustomerHomeCountryNameSelector, MetadataCodeTypeSelector(CODES.Language), MetadataCodeTypeSelector(CODES.SubscriberType)], function (customer, customerCurrencyName, customerHomeCountryName, languages, subscriberTypeCodes) {
  return customer.Id ? {
    firstName: customer.FirstName,
    lastName: customer.LastName,
    categoryCode: customer.Category,
    category: i18n.translate(customer.Category === CUSTOMER_CATEGORY.COMMERCIAL ? LocaleKeys.COMMERCIAL : LocaleKeys.RESIDENTIAL),
    companyName: customer.CompanyName,
    typeCode: customer.SubscriberTypeCode,
    type: codeTypeFilter(customer.SubscriberTypeCode, subscriberTypeCodes),
    homeCountryName: customerHomeCountryName,
    currencyName: customerCurrencyName,
    language: getNameByCountryCode(languages, customer.Language)
  } : EMPTY_OBJECT;
});
export var DestinationCustomerAccountInfoViewModelSelector = createImmutableSelector([SelectedDestinationCustomerSelector, InvoiceDisplaySelector, DestinationCustomerInvoiceDetailStatus], function (customer, invoiceDisplays, invoiceDetailStatus) {
  var invoiceDisplay = pathOr(undefined, ['SubscriberTypeDetails', 'InvoiceDisplay'], customer);
  var hideZeroAmount = pathOr(undefined, ['InvoiceConfiguration', 'HideZeroAmount'], customer);
  return customer.Id ? {
    email: customer.Email,
    login: customer.Login,
    state: customer.State,
    stateName: customer.StateName,
    invoiceDisplay: invoiceDisplay,
    invoiceDisplayValue: getInvoiceDisplayValue(invoiceDisplay, invoiceDisplays),
    invoiceDetailStatus: invoiceDetailStatus,
    billCycle: pathOr(undefined, ['SubscriberTypeDetails', 'BillCycle'], customer),
    hideZeroAmount: i18n.translate(hideZeroAmount ? LocaleKeys.PROFILE_PAGE.ENABLED : LocaleKeys.PROFILE_PAGE.DISABLED)
  } : EMPTY_OBJECT;
});
var getInvoiceDisplayValue = function getInvoiceDisplayValue(invoiceDisplay, invoiceDisplays) {
  var selectedInvoiceDisplay = invoiceDisplays.find(function (invoice) {
    return invoice.Value === invoiceDisplay;
  });
  return pathOr('', ['Name'], selectedInvoiceDisplay);
};
export var DestinationCustomerAdditionalPropertiesSortedByDisplayOrderSelector = createImmutableSelector([DestinationCustomerAdditionalPropertiesSelector, SubscriberAdditionalPropertiesSelector], function (customerAdditionalProperties, subscriberAdditionalPropertyFields) {
  return getCustomerAdditionalPropertiesSortedByDisplayOrder(customerAdditionalProperties, subscriberAdditionalPropertyFields);
});
var getDisabledCustomerStateTooltipObject = function getDisabledCustomerStateTooltipObject() {
  return _defineProperty(_defineProperty(_defineProperty({}, CUSTOMER_STATE.ANONYMIZED, {
    tooltipMessage: i18n.translate(LocaleKeys.TRANSFER.CONFIG_STEP.SEARCH_CUSTOMER_DIALOG.ANONYMIZED_DISABLED_TOOLTIP)
  }), CUSTOMER_STATE.BLOCKLISTED, {
    tooltipMessage: i18n.translate(LocaleKeys.TRANSFER.CONFIG_STEP.SEARCH_CUSTOMER_DIALOG.BLOCKLISTED_DISABLED_TOOLTIP)
  }), CUSTOMER_STATE.PROSPECT_LITE, {
    tooltipMessage: i18n.translate(LocaleKeys.TRANSFER.CONFIG_STEP.SEARCH_CUSTOMER_DIALOG.PROSPECT_LITE_DISABLED_TOOLTIP)
  });
};
export var DestinationCustomerSearchResultsViewModelSelector = createImmutableSelector([CustomerSearchResultsViewModelSelector], function (customerSearchResults) {
  return customerSearchResults.length ? customerSearchResults.map(function (customerSearchResult) {
    return Object.assign({}, customerSearchResult, {
      isDisabled: customerSearchResult.isDisabled || !!getDisabledCustomerStateTooltipObject()[customerSearchResult.state],
      tooltipMessage: customerSearchResult.tooltipMessage || (getDisabledCustomerStateTooltipObject()[customerSearchResult.state] || {}).tooltipMessage
    });
  }) : EMPTY_ARRAY;
});